module.exports = __webpack_public_path__ + "images/mdekoning_smallbf1c016f5c662f0cd901c19622a5141a.png";